import React, { useState, useContext, useEffect } from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import stateContext from "../Context/StateContext";
import '../App.css'

const languageLabels = ["English", "البدء"];

const Header = () => {
    const globalState = useContext(stateContext);
    const [activeButtonIndex, setActiveButtonIndex] = useState(0);
    const searchParams = new URLSearchParams(window.location.search);
    const getLanguageFromParams = searchParams.get('language');
    const onlyOne = searchParams.get('onlyOne');

    useEffect(() => {
        if(getLanguageFromParams === "Arabic"){
            setActiveButtonIndex(1)
            globalState.setSelectedFontLanguage("Arabic")
            document.body.classList.add("arabicSelected");
        }else{
            setActiveButtonIndex(0)
            globalState.setSelectedFontLanguage("English");
            document.body.classList.remove("arabicSelected");
        }
    }, []);

    const handleButtonClick = (index) => {
        setActiveButtonIndex(index);

        let language;
        if (index === 0) {
            language = 'English';
            globalState.setText("Haref");
            document.body.classList.remove("arabicSelected");
        } else if (index === 1) {
            language = 'Arabic';
            globalState.setText("نوف");
            document.body.classList.add("arabicSelected");
        }
        globalState.setSelectedFontLanguage(language);
    };

    if (onlyOne === 'true') {
        return null;
    }

    return (
        <header className="header">
            {/* Logo Section */}
            <div className="header__logo">
            </div>
            {/* Language Buttons */}
            <ButtonGroup
                variant="contained"
                aria-label="outlined primary button group"
                className="header__buttons"
            >
                {languageLabels.map((label, index) => (
                    <Button
                        key={index}
                        className={`header__button ${activeButtonIndex === index ? "active" : ""}`}
                        onClick={() => handleButtonClick(index)}
                    >
                        {label}
                    </Button>
                ))}
            </ButtonGroup>
        </header>
    )
}

export default Header;